import { ActionCommand, ShiftData } from '@nextforce/api'
import { makeStyles } from '@rneui/themed'
import React from 'react'
import { SafeAreaView } from 'react-native-safe-area-context'
import { CommandButtons } from 'shared/components/command_buttons'
import { SwapCoverDetails } from 'shared/components/shift/swap_cover_details'

interface Props {
  shiftData: ShiftData | undefined | null
  onConfirm: (command: ActionCommand) => Promise<void>
}

export function SwapCoverShiftView({ shiftData, onConfirm }: Props) {
  const styles = useStyles()

  return (
    <SafeAreaView edges={['left', 'right', 'bottom']} style={styles.container}>
      <SwapCoverDetails shiftData={shiftData} />
      <CommandButtons
        commands={shiftData?.candidates && shiftData?.candidates[0].commands}
        onButtonPress={onConfirm}
      />
    </SafeAreaView>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    flex: 1,
    justifyContent: 'space-between',
    backgroundColor: theme.colors?.grey5,
  },
}))
